function cov_x88mnve9v() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/EditFilled.tsx";
  var hash = "01ffdc1c38bd71bf477d540efefce6fb65effdcf";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/EditFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "01ffdc1c38bd71bf477d540efefce6fb65effdcf"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_x88mnve9v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_x88mnve9v();
var Icon = (cov_x88mnve9v().s[0]++, {
  name: 'edit-filled',
  svg: "<path d=\"M2.98477 19.7021L4.99997 15L5.0428 14.9572L9.04279 18.9572L8.99997 19L4.29783 21.0152C3.46811 21.3708 2.62917 20.5319 2.98477 19.7021Z\" fill=\"currentColor\"/>\n  <path d=\"M10.457 17.543L17.5428 10.4572L13.5428 6.45719L6.45702 13.543L10.457 17.543Z\" fill=\"currentColor\"/>\n  <path d=\"M14.957 5.04297L18.957 9.04297L20.5858 7.41422C21.3668 6.63317 21.3668 5.36684 20.5858 4.58579L19.4142 3.41422C18.6331 2.63317 17.3668 2.63317 16.5858 3.41422L14.957 5.04297Z\" fill=\"currentColor\"/>"
});
export default Icon;